const SET_SELECTED_BRANCH = 'SET_SELECTED_BRANCH';
const SET_SELECTED_REQUEST_TYPE = "SET_SELECTED_REQUEST_TYPE";
const SET_TRANSFER_ORDER_DETAILS = "SET_TRANSFER_ORDER_DETAILS";
const SET_TRANSFER_ORDER_NUMBER = "SET_TRANSFER_ORDER_NUMBER"
const ORDER_CREATION_SUCCESS = "ORDER_CREATION_SUCCESS"
const SET_IDISPOSITION = "SET_IDISPOSITION"
const SET_CART_IDISPOSITION = "SET_CART_IDISPOSITION"

const SET_TRANSFER_REQUEST_DATA = "SET_TRANSFER_REQUEST_DATA"
const SET_ASSET_DATA = "SET_ASSET_DATA"
const SET_ASSET_CART_DATA = "SET_ASSET_CART_DATA"
const SET_ALL_CART_ASSET = "SET_ALL_CART_ASSET"

const SET_REACTIVATION_REQUEST_DATA = "SET_REACTIVATION_REQUEST_DATA"

// EDIT Order
const SET_IS_EDIT_ORDER = "SET_IS_EDIT_ORDER"
const SET_IS_RESET_CLICKED = "SET_IS_RESET_CLICKED"

const SET_IS_LAST_REQUEST_DELETED = "SET_IS_LAST_REQUEST_DELETED"
const SET_IS_CART_NOT_UPDATED = "SET_IS_CART_NOT_UPDATED"

const SET_IS_SAVE_AS_DRAFT = "SET_IS_SAVE_AS_DRAFT"
const SET_IS_CHANGES_OCCURED_IN_CART = "SET_IS_CHANGES_OCCURED_IN_CART"

const SET_IS_COSTCENTER_AVAILABLE_FOR_SUBMIT = "SET_IS_COSTCENTER_AVAILABLE_FOR_SUBMIT"

/// AFE

const SET_AFE_RECLASSIFICATION_DATA = "SET_AFE_RECLASSIFICATION_DATA"

const GET_LEADR_ORDER_VALIDATION = "GET_LEADR_ORDER_VALIDATION" 
const SET_LEADR_ORDER_VALIDATION = "SET_LEADR_ORDER_VALIDATION"

const SET_AFE_ASSET_DETAIL_DATA = "SET_AFE_ASSET_DETAIL_DATA"

const SET_AFE_BRANCH_ADDRESS_DETAIL = "SET_AFE_BRANCH_ADDRESS_DETAIL"

const GET_VALIDATE_AFE_ASSET_NUMBER = "GET_VALIDATE_AFE_ASSET_NUMBER"
const SET_VALIDATE_AFE_ASSET_NUMBER = "SET_VALIDATE_AFE_ASSET_NUMBER"

const GET_SAVE_AFE_RECLASSIFICATION = "GET_SAVE_AFE_RECLASSIFICATION"
const SET_SAVE_AFE_RECLASSIFICATION = "SET_SAVE_AFE_RECLASSIFICATION"

const GET_AFE_ORDER_BY_ID = "GET_AFE_ORDER_BY_ID"
const SET_AFE_ORDER_BY_ID = "SET_AFE_ORDER_BY_ID"

const GET_VALIDATE_ASSETS_ON_SAVE = "GET_VALIDATE_ASSETS_ON_SAVE"
const SET_VALIDATE_ASSETS_ON_SAVE = "SET_VALIDATE_ASSETS_ON_SAVE"

export {
    SET_SELECTED_BRANCH,
    SET_SELECTED_REQUEST_TYPE,
    SET_TRANSFER_ORDER_DETAILS,
    SET_TRANSFER_ORDER_NUMBER,
    ORDER_CREATION_SUCCESS,
    SET_IS_EDIT_ORDER,
    SET_IDISPOSITION,
    SET_CART_IDISPOSITION,
    SET_TRANSFER_REQUEST_DATA,
    SET_ASSET_DATA,
    SET_ASSET_CART_DATA,
    SET_REACTIVATION_REQUEST_DATA,
    SET_IS_RESET_CLICKED,
    SET_IS_LAST_REQUEST_DELETED,
    SET_IS_CART_NOT_UPDATED,
    SET_ALL_CART_ASSET,
    SET_IS_SAVE_AS_DRAFT,
    SET_IS_CHANGES_OCCURED_IN_CART,
    SET_IS_COSTCENTER_AVAILABLE_FOR_SUBMIT,
    SET_AFE_RECLASSIFICATION_DATA,
    GET_LEADR_ORDER_VALIDATION,
    SET_LEADR_ORDER_VALIDATION,
    SET_AFE_ASSET_DETAIL_DATA,
    SET_AFE_BRANCH_ADDRESS_DETAIL,
    GET_VALIDATE_AFE_ASSET_NUMBER,
    SET_VALIDATE_AFE_ASSET_NUMBER,
    GET_SAVE_AFE_RECLASSIFICATION,
    SET_SAVE_AFE_RECLASSIFICATION,
    GET_AFE_ORDER_BY_ID,
    SET_AFE_ORDER_BY_ID,
    GET_VALIDATE_ASSETS_ON_SAVE,
    SET_VALIDATE_ASSETS_ON_SAVE
};
